// User-facing copy: clubs. Moved from the web app (pages/Clubs.tsx, pages/Directory.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** pages/Clubs.tsx */
export const list = {
    passed: "passed",
    today: "today",
    tomorrow: "tomorrow",
    inDays: (days) => `in ${days} days`,
    yourProfile: "Your profile",
    noClubsYet: "No clubs yet",
    startOneForYour: "Start one for your group, or open an invite link a friend sent you.",
    youRunFiveClubs: "You run five clubs, the most one person can own. To start another, hand one to another member or delete one from its Club settings.",
    startAClub: "Start a club",
    findAClubTo: "Find a club to join",
    invitedToOneOpen: "Invited to one? Open the link you were sent.",
    finished: "finished",
    youReAt: (myProgress) => `you're at ${myProgress}%`,
    nothingStartedOnDeck: (onDeckCount) => `Nothing started · ${onDeckCount} on deck`,
    nothingOnTheNightstand: "Nothing on the nightstand yet",
    new: (unreadMessages) => `${unreadMessages} new`,
};
/** pages/Directory.tsx */
export const directory = {
    /** the filter chips */
    chipReadingNow: "Reading now",
    chipReading: (title) => `Reading ${title}`,
    chipGenre: "Genre",
    chipGenres: (n) => `Genre · ${n}`,
    chipPace: "Pace",
    chipSize: "Size",
    chipHowToJoin: "How to join",
    smallUnder10: "Small · under 10",
    medium1050: "Medium · 10–50",
    large50: "Large · 50+",
    open: "Open",
    requestToJoin: "Request to join",
    mostActive: "Most active",
    newest: "Newest",
    mostMembers: "Most members",
    yourClubs: "Your clubs",
    findAClub: "Find a club",
    clubsThatWelcomeNew: "Clubs that welcome new members.",
    searchClubsByName: "Search clubs by name or description",
    filters: "Filters",
    clear: "Clear",
    clubsReading: "Clubs reading ",
    anyBook: "Any book",
    pagesADay: (label, x) => `${label} · ${x} pages a day`,
    looking: "Looking…",
    club: "club",
    clubs: "clubs",
    sort: "Sort",
    noClubsMatch: "No clubs match",
    noClubsToFind: "No clubs to find yet",
    tryFewerFiltersOr: "Try fewer filters or a different search.",
    whenClubsChooseTo: "When clubs choose to be found, they'll be here.",
    loading: "Loading…",
    show20More: "Show 20 more",
    openItsPage: (name) => `${name}: open its page`,
    member: "Member",
    join: "Join",
    ask: "Ask",
    member2: "member",
    members: "members",
    reading: (title) => ` · reading ${title}`,
    spoilersNotHidden: "Spoilers not hidden",
};
//# sourceMappingURL=clubs.js.map